import { h } from 'preact';

import Alert from '@mui/material/Alert';

export default function RunnerAppealMessage(_props) {
  return (
    <Alert severity="info">
      Contact{' '}
      <a href="mailto:support@rebelmouse.com" target={'_blank'}>
        <b>support@rebelmouse.com</b>
      </a>{' '}
      if you need any help
    </Alert>
  );
}
